import { useEffect, useState } from "react";
import { useSpring, animated } from "@react-spring/web";

import { Box, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import characterAgent from "../../../../Assets/StoryRunner/agent.png";
import characterRunner from "../../../../Assets/StoryRunner/runner_2.png";

import Message from "../../../Commons/Message";

import Backdrop from "../../../Commons/Backdrop";

import connectWithDispatch from "../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../Actions/appActions";

interface StageProps {
  stage: number;
  transition: number;
  setStory: (value: Partial<StoryType>) => void;
}

const StageTwo = (props: StageProps) => {
  const { stage, transition, setStory } = props;
  const [answerChoosed, setAnswerChoosed] = useState<string>("");

  const viewportHeight = window.innerHeight;

  const move165 = viewportHeight * 0.1776;

  useEffect(() => {
    if (transition >= 1 && transition < 4) setTimeout(() => setStory({ transition: transition + 1, animating: true }), 650);
    if (transition === 4) setTimeout(() => setStory({ animating: false }), 100);
    if (transition === 5) setTimeout(() => setStory({ transition: transition + 1 }), 1500);
    if (transition === 6) setTimeout(() => setStory({ transition: transition + 1 }), 1500);
    if (transition === 7) setTimeout(() => setStory({ transition: transition + 1 }), 1500);
    if (transition === 8) setTimeout(() => setStory({ animating: false }), 100);
    if (transition === 9) setTimeout(() => setStory({ stage: stage + 1, transition: 1, screen: 0 }), 1200);

    return () => {};
  }, [stage, transition, setStory]);

  const getTranslateYChatBox = () => {
    switch (transition) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        return `translateY(0px)`;
      case 6:
        return `translateY(-${move165}px)`;
    }
  };

  const propsOpacityContainer = useSpring({
    opacity: transition >= 2 && transition < 9 ? 1 : 0,
    config: { duration: transition === 9 ? 300 : 800 },
  });

  const propsCharacterAgent = useSpring({
    zIndex: -1,
    position: "absolute" as "absolute",
    left: transition >= 9 ? "-150%" : "-50%",
    width: "35.556vh",
    bottom: "-0.5em",
    config: { duration: 600 },
  });

  const propsCharacterRunner = useSpring({
    zIndex: -1,
    position: "absolute" as "absolute",
    right: transition >= 9 ? "-150%" : "-59%",
    width: "47.315vh",
    bottom: "-0.5em",
    config: { duration: 600 },
  });

  const propsChatBox = useSpring({
    transform: getTranslateYChatBox(),
    config: { duration: 300 },
  });

  const propsFirstMsg = useSpring({
    width: "38.8em",
    left: 0,
    position: "absolute" as "absolute",
    opacity: transition >= 3 ? 1 : 0,
    config: { duration: 300 },
  });

  const propsSecondMsgOptions = useSpring({
    width: "38.8em",
    left: 0,
    top: transition > 3 ? "calc(50vh + 13.88vh)" : "calc(50vh + 18vh)",
    position: "absolute" as "absolute",
    opacity: transition === 4 ? 1 : 0,
    config: { duration: 600 },
  });

  const propsSecondMsgAnswer = useSpring({
    zIndex: transition >= 5 ? 10 : -1,
    width: "38.8em",
    left: 0,
    top: transition > 3 ? "calc(50vh + 13.88vh)" : "calc(50vh + 18vh)",
    position: "absolute" as "absolute",
    opacity: transition >= 5 ? 1 : 0,
    config: { duration: 600 },
  });

  const propsThirdMsg = useSpring({
    zIndex: transition >= 6 ? 10 : -1,
    width: "38.8em",
    left: 0,
    top: "calc(50vh + 29.38vh)",
    position: "absolute" as "absolute",
    opacity: transition >= 6 ? 1 : 0,
    config: { duration: 1200 },
  });

  const propsBtn = useSpring({
    opacity: transition >= 8 ? 1 : 0,
    config: { duration: 600 },
  });

  const answer_1 =
    "The new system has really changed things around here. And for the better. Alright Steve, I’ll see you after your shift.";
  const answer_2 =
    "Ha! That’s being hopeful. But glad things are smooth on our end with the new system in place. Alright I’ll see you after your shift.";

  return (
    <>
      {transition <= 4 && <Backdrop show={transition > 0} duration={600} />}
      {transition > 4 && <Backdrop duration={600} show={transition >= 9} from={"#00000099"} to={"transparent"} />}
      <Box style={{ ...styles.container }}>
        <animated.div style={{ ...styles.containerBox, ...propsOpacityContainer }}>
          <animated.div style={{ ...propsCharacterAgent }}>
            <img src={characterAgent} alt="" style={{ width: "100%" }} />
          </animated.div>
          <animated.div style={{ ...propsCharacterRunner }}>
            <img src={characterRunner} alt="" style={{ width: "100%" }} />
          </animated.div>
          <animated.div style={{ ...styles.chatBox, ...propsChatBox }}>
            <animated.div style={{ ...propsFirstMsg }}>
              <Message
                name={"Jen"}
                message={
                  "Heads up John, 30 minutes delays on several connecting flights due to runway traffic. Let’s keep our systems online and we should be good."
                }
              />
            </animated.div>
            <animated.div style={{ ...propsSecondMsgOptions }}>
              <Box sx={styles.btnBox}>
                <Button
                  onClick={() => {
                    setAnswerChoosed("first");
                    setStory({ transition: transition + 1, animating: true });
                  }}
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                >
                  Yep all good! Just finished my break.
                </Button>
              </Box>
              <Box sx={{ ...styles.btnBox, marginTop: "1.041em" }}>
                <Button
                  onClick={() => {
                    setAnswerChoosed("second");
                    setStory({ transition: transition + 1, animating: true });
                  }}
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                >
                  Ok... and I thought it was goind to be an easy day.
                </Button>
              </Box>
            </animated.div>
            <animated.div style={{ ...propsSecondMsgAnswer }}>
              <Message
                align="right"
                name={"John"}
                message={
                  answerChoosed !== "" && answerChoosed === "second"
                    ? "Ok... and I thought it was goind to be an easy day."
                    : "Yep all good! Just finished my break."
                }
              />
            </animated.div>
            <animated.div style={{ ...propsThirdMsg }}>
              <Message name={"Jen"} message={answerChoosed !== "" && answerChoosed === "second" ? answer_2 : answer_1} />
            </animated.div>
          </animated.div>
          <animated.div style={{ ...styles.btnContainer, ...propsBtn }}>
            <Button onClick={() => setStory({ transition: transition + 1 })} variant="contained" endIcon={<ArrowForwardIcon />}>
              Continue
            </Button>
          </animated.div>
        </animated.div>
      </Box>
    </>
  );
};

const styles = {
  container: {
    overflow: "hidden !important",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  containerBox: {
    position: "relative" as "relative",
    width: "38.8em",
    height: "100vh",
    display: "flex",
    zIndex: 0,
  },
  chatBox: {
    position: "relative" as "relative",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column" as "column",
  },
  btnBox: {
    justifyContent: "flex-end",
    display: "flex",
  },
  btnContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    width: "100%",
    margin: "5em 0",
    zIndex: -1,
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    stage: state.appReducer.story.stage,
    transition: state.appReducer.story.transition,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(StageTwo, mapStateToProps, mapDispatchToProps);
